<button
  mat-icon-button
  class="sm:!text-white"
  [matMenuTriggerFor]="profile_menu"
>
  <mat-icon>person</mat-icon>
</button>

<mat-menu #profile_menu="matMenu">
  <a routerLink="user/change-password">
    <button mat-menu-item>
      <mat-icon>refresh-square</mat-icon>
      <span>تغییر رمزعبور</span>
    </button>
  </a>

  <button mat-menu-item (click)="logout()">
    <mat-icon>logout</mat-icon>
    <span>خروج</span>
  </button>
</mat-menu>
